export default __webpack_public_path__ + "static/media/ppal.133a3d85.png";